import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { ApiService } from '../core/services/api.service';
import { Apiconfig } from '../core/helpers/apiConfig';

@Component({
  selector: 'app-view',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './view.component.html',
  styleUrl: './view.component.scss'
})
export class ViewComponent implements OnInit {
  showLeftBanner: Boolean = false;
  showrightBanner: Boolean = false;
  environment = environment;
  pageHeading = 'Best IVF Center in Kannur, Kerala';
  reloadAction: number = 1;
  isBrowser: boolean = false;
  blogs: any[] = [];
  apiUrl = environment.apiUrl;

  testimonalSlider = {
    dots: false,
    nav: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  constructor(
    private route: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private metaService: Meta,
    private apiService: ApiService,

    private titleService: Title,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.titleService.setTitle('NCARE IVF Centre | Best IVF Center in Kannur');
    this.metaService.updateTag({
      name: 'description',
      content: 'Expert IVF, IUI, and fertility solutions at NCARE Best IVF Centre in Kannur, Kerala. Start your journey to parenthood with our compassionate care.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'fertility center, fertility treatment, best fertility centre, best ivf clinic in Kannur, best ivf clinic in Kerala, fertility clinic near me, Fertility Center in Kannur, Fertility Center in Kerala, best ivf center in kannur, fertility clinic kannur, ivf treatment in kannur, Best IVF Centre in India, Best IVF Clinics, IVF Hospital in Kerala, Best IVF Centre in kerala, Infertility Hospital Near Me, ivf hospital near me, ivf center near me, Fertility Center'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'NCARE IVF Centre | Best IVF Center in Kannur'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Expert IVF, IUI, and fertility solutions at NCARE Best IVF Centre in Kannur, Kerala. Start your journey to parenthood with our compassionate care.'
    });

    this.reloadAction = 0;
  }

  ngOnInit(): void {
    this.metaUpdate();
    if (this.isBrowser) {
      const homeSchema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "NCare IVF Kannur, Kerala",
        "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
        "@id": "https://ncareivfkannur.com/",
        "url": "https://ncareivfkannur.com/",
        "telephone": "8606443030",
        "priceRange": "₹",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
          "addressLocality": "Kannur, Kerala",
          "postalCode": "670001",
          "addressCountry": "IN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 11.8710259,
          "longitude": 75.3641411
        },
        "sameAs": [
          "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
          "https://www.instagram.com/ncareivfkannur/",
          "https://www.youtube.com/@NCAREIVFKANNUR/"
        ]
      };

      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(homeSchema);
      this.renderer.appendChild(this.document.head, script);

      if (![2, 3].includes(this.reloadAction)) {
        window.scrollTo(0, 0);
      }
      this.fetchBlogs();
    }
  }

  fetchBlogs() {
    this.apiService.commonApi(Apiconfig.listPage.method, Apiconfig.listPage.url, {}).subscribe((result: any) => {
      if (result && Array.isArray(result)) {
        this.blogs = result.slice(0, 4);
      }
    });
  }

  extractFirstHeading(description: string): string {
    if (!description) return '';
    const match = description.match(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/i);
    return match ? match[0] : '';
  }

  contactus() {
    this.route.navigate(['/contact-us']);
  }

  metaUpdate() {
    this.apiService.commonApi(Apiconfig.landingData.method, Apiconfig.landingData.url, {}).subscribe((result: any) => {
      if (result && Array.isArray(result.response)) {
        const settingsEntry = result.response.find((e: any) => e.Settings);
        if (settingsEntry) {
          const general = settingsEntry.Settings.settings;
          if (general && general.meta) {
            const keywordsArray = Array.isArray(general.meta.meta_keyword) ? general.meta.meta_keyword : [];
            const keywordsString = keywordsArray.join(', ');

            // if (this.isBrowser) {
            //   this.apiService.setAppFavicon(general.favicon);
            // }

            // this.titleService.setTitle(general.meta.meta_title);
            // this.metaService.updateTag({ name: 'keywords', content: keywordsString });
            // this.metaService.updateTag({ name: 'description', content: general.meta.meta_description });
            // this.metaService.updateTag({ name: 'og:title', content: general.meta.meta_title });
            // this.metaService.updateTag({ name: 'og:description', content: general.meta.meta_description });
            // this.metaService.updateTag({ name: 'author', content: 'NCare IVF Kannur, Kerala' });
            // this.metaService.updateTag({ name: 'publisher', content: 'NCare IVF Kannur, Kerala' });
          }
        }
      }
    });
  }

  slickInit(e: any) {
    // console.log('slick initialized');
  }
}
